import { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { baseApiURL, apiEndPoints } from '../config'

interface IDataParams {
  q: string
  pageSize: number
  pageNumber: number
  isCorporate?: boolean
  isProgressReport?: boolean
}

export default class Apply {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}apply`
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async getStudentRecordList(params?: IDataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.studentRecord}?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }&&isProgressReport=${params?.isProgressReport}&&isCorporate=${params?.isCorporate}`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching student record list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getMasterData() {
    const url = `${this.baseUrl}/${apiEndPoints?.loadMasterData}`

    try {
      const response = await this.apiServer.get(url)
      const result = response?.data?.data ? response?.data?.data : null

      return result
    } catch (err: any) {
      console.log('Error fetching student record list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getStudentList(params: any) {
    let endUrlName = `${this.baseUrl + apiEndPoints.studentRecords}?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }`
    if (params?.status) endUrlName = `${endUrlName}&&status=${params?.status}`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`
    if (params?.isCorporate != undefined && params?.isCorporate != null)
      endUrlName = `${endUrlName}&&isCorporate=${params?.isCorporate}`
    try {
      const response = await this.apiServer.get<any>(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error fetching student list ========>', err?.message)
    }
  }
  async checkDuplicateIdNumber(idNumber: string, leadId: string) {
    const route = apiEndPoints?.checkDuplicateIdNumber.replace(':idNumber', idNumber).replace(':leadId', leadId)
    const url = `${this.baseUrl}/${route}`
    const response = await this.apiServer.get(url)
    const result = response?.data?.data ? response?.data?.data : null

    return result
  }
  async getStudentDetail(studentCode: string) {
    const route = apiEndPoints?.getStudentDetail?.replace(':studentCode', studentCode)
    const endUrlName = `${this.baseUrl + route}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data ? response?.data?.data : null
    } catch (err: any) {
      console.log('Error Updating student Type ========>', err)
    } finally {
      nProgress.done()
    }
  }

  async getStudentDetailProgresReport(appCode: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.studentDetailsProgressReport}/${appCode}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data ? response?.data?.data : null
    } catch (err: any) {
      console.log('Error Updating student Type ========>', err)
    } finally {
      nProgress.done()
    }
  }
}
